export interface AudioPlaybackClaim {
  isCurrent: () => boolean;
  release: () => void;
  token: symbol;
}

type StopPlayback = () => void;

let activePlayback: { stop: StopPlayback; token: symbol } | null = null;

export function claimAudioPlayback(stop: StopPlayback): AudioPlaybackClaim {
  stopActiveAudioPlayback();

  const token = Symbol("audio-playback");
  activePlayback = { stop, token };

  return {
    isCurrent: () => activePlayback?.token === token,
    release: () => releaseAudioPlayback(token),
    token
  };
}

export function releaseAudioPlayback(token: symbol) {
  if (activePlayback?.token === token) {
    activePlayback = null;
  }
}

export function stopActiveAudioPlayback() {
  const playback = activePlayback;

  if (!playback) {
    return;
  }

  activePlayback = null;
  playback.stop();
}
